var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","flat":"","dark":"","color":"navBarColor"}},[_c('v-spacer'),_c('v-toolbar-items',[_c('notifications'),_c('profileMenu')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }